import UiModal from '../../../../js/components/UiModal/UiModal'
import Form from '../../../../js/Form/Form'
import { defaultRules } from '../../../../js/Form/default-rules'
import { createElement, render } from '../../../../js/utils/render'
import { Media } from '../../../../js/utils/const'
import { getVkAuthModel } from '../../../../js/components/VKConnect'

class ContactsMobileModal extends UiModal {
  /**
   * @param {HTMLElement} template
   * @param {Object} options
   * @param {Array} options.hiddenFields
   * @param {Function} options.submitHandler
   * @param {Function} options.closeHandler
   */
  constructor(template, options = {}) {
    super(template, {
      wrapperClass: 'contacts-mobile-modal',
      blockTriggerName: options.blockName,
      outerScroll: true,
      isIndent: false
    })

    this.form = null
    this.content = template

    this.hiddenFields = this.getHiddenFields(JSON.parse(template.dataset.hiddenFields), options.hiddenFields)
    this.submitHandler = options.submitHandler
    this.closeHandler = options.closeHandler
    this.paymentPrice = options.paymentPrice
    this.paymentType = options.paymentType
    this._desktopMedia = window.matchMedia(`(min-width: ${Media.LG}px)`)
    this._desktopListener = null
  }

  beforeMounted() {
    this.form = this.element.querySelector('.form')
    this.submitButton = this.form.querySelector('.contacts-mobile-modal__button')

    this.formInit()

    this._desktopListener = () => { if (this._desktopMedia.matches) this.close() }
    this._desktopMedia.addEventListener('change', this._desktopListener)
  }

  beforeUnmounted() {
    this.form.removeEventListener('form-sended', this.submitFormHandler)
    this._desktopMedia.removeEventListener('change', this._desktopListener)
  }

  beforeClose() {
    this.closeHandler?.()
  }

  setButtonContent({paymentPrice, paymentType})  {
    this.submitButton.classList.toggle('contacts-mobile-modal__button--with-price', !!paymentPrice)
    this.submitButton.querySelector('.ui-button__text').innerHTML = `
      <span class="f f--16 f--m">${paymentType}</span>
      ${paymentPrice ? `<span class="f f--12">${paymentPrice}</span>` : ''}`
  }


  async formInit() {
    const vkConnectContainer = this.element.querySelector('[data-auth="vk-connect"]')
    const vkAuthModel = await getVkAuthModel([vkConnectContainer])

    this.renderHiddenFields(this.form, this.hiddenFields)
    this.setButtonContent({ paymentPrice: this.paymentPrice, paymentType: this.paymentType })
    this.form.addEventListener('form-sended', this.submitFormHandler)
    this.form.addEventListener('form-alchemere', this.close)

    new Form({
      vkAuthModel,
      form: this.form,
      rules: {
        name: defaultRules.name,
        phone: defaultRules.phone,
        email: defaultRules.email,
        policy_accepted: defaultRules.policy_accepted
      },
      blockName: 'Contacts Mobile Modal'
    }).init()
  }

  submitFormHandler = (evt) => {
    this.submitHandler?.(evt)
  }

  getHiddenFields(mainFields, newFields) {
    if (!newFields) {
      return mainFields
    }

    const fieldsMap = [...mainFields, ...newFields].reduce((acc, item) => {
      acc[item.name] = item.value
      return acc
    }, {})

    return Object.keys(fieldsMap).map(name => ({ name, value: fieldsMap[name] }))
  }

  renderHiddenFields(container, hiddenFields) {
    const fragment = document.createDocumentFragment()

    hiddenFields.forEach(({ name, value }) => {
      const hiddenField = createElement(`<input name="${name}" type="hidden" value="${value}">`)
      render(fragment, hiddenField)
    })

    render(container, fragment)
  }
}

export const showContactsMobileModal = (options) => {
  const template = document.querySelector('#contacts-mobile-modal')?.content
    .cloneNode(true).querySelector('.contacts-mobile-modal__wrapper');

  if (!template) {
    const err = new Error(`[Contacts Mobile Modal]: шаблон с id=contacts-mobile-modal отсутствует`)
    console.error(err)
    window.Sentry?.captureException(err)
    return
  }

  const contactsMobileModal = new ContactsMobileModal(template, options)
  contactsMobileModal.init()

  return contactsMobileModal
}
